/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-new-mixins */
import { computed } from '@ember/object';
import { and, not, or, readOnly, reads } from '@ember/object/computed';
import Mixin from '@ember/object/mixin';
import { ARTICLES_FEATURE, INBOX_FEATURE, MESSAGES_FEATURE } from 'embercom/lib/billing';
import IntercomradesProductsOverride from 'embercom/lib/intercomrades-products-override';
import localFeatureFlags from 'embercom/lib/local-feature-flags';

export const nameForTestFeatureEnabledByGlobalFeatureFlagDefaults =
  '_test-ff-enabled-by-global-defaults';
export const nameForTestFeatureDisabledByGlobalFeatureFlagDefaults =
  '_test-ff-disabled-by-global-defaults';

const generateFeatureFlagConfig = ({ flattenComputed } = { flattenComputed: false }) => {
  let ComputedCanUseFeature;
  if (flattenComputed) {
    ComputedCanUseFeature = (featureKey) => featureKey;
  } else {
    ComputedCanUseFeature = function (featureKey) {
      return computed('features.[]', 'localStorageFeatures.[]', function () {
        return this.canUseFeature(featureKey);
      });
    };
  }
  return {
    //team-data-foundations
    useBulkExportNewUI: ComputedCanUseFeature('bulk-export-new-ui'),
    canLogSamlEventData: ComputedCanUseFeature('workspace-management-log-saml-event-data'),
    canUseSamlSso: ComputedCanUseFeature('saml_sso'),
    canUseSamlMultiWorkspaces: ComputedCanUseFeature('rails-dev-platform-saml-multi-workspaces'),
    canManageTeamsGranularly: ComputedCanUseFeature('manage-teams-permission'),
    hasLegacyWebhookAccess: ComputedCanUseFeature('team-data-foundations-legacy-webhook-access'),
    canUseHmacSignature: ComputedCanUseFeature('team-data-foundations-hmac-signature'),
    canUsePlanEditorSearch: ComputedCanUseFeature('embercom-app-serializer-limit-external-plans'),

    //team-actions - procedures workstream
    canUseFinProcedures: ComputedCanUseFeature('team-actions-fin-procedures-new-ui'),
    canUseFinProceduresDedicatedPage: ComputedCanUseFeature(
      'team-actions-fin-procedures-dedicated-page',
    ),
    canUseAiProcedureGeneration: ComputedCanUseFeature(
      'team-actions-fin-procedures-ai-procedure-generation-modal',
    ),
    canUseProceduresHandoffOutcome: ComputedCanUseFeature('procedures-handoff-outcome'),

    //team-actions
    canUseGithubWorkflowsAlpha: ComputedCanUseFeature('github-workflows-alpha'),
    canUseJiraInboundWorkflows: ComputedCanUseFeature('inbound-jira-webhooks'),
    useAppCardApi: ComputedCanUseFeature('marketplace-app-card-api'),
    showAppsInBotsPaywall: ComputedCanUseFeature('marketplace-validate-apps-in-operator'),
    isDevHubAppPartnerEnabled: ComputedCanUseFeature('app-ecosystem-dev-hub-app-partner'),
    isExistingAppPartner: ComputedCanUseFeature(
      'app-ecosystem-dev-hub-app-partner-existing-partner',
    ),
    notExistingAppPartner: not('isExistingAppPartner'),
    canShowDevHubAppPartner: and('isDevHubAppPartnerEnabled', 'notExistingAppPartner'),
    canUseWorkflowConnectorActionMacros: ComputedCanUseFeature('ae-wfc-macros'),
    canUseNewWorkflowsJiraInstallation: ComputedCanUseFeature(
      'team-data-interop-new-workflows-jira-installation-flow',
    ),
    canUseCodeBlocks: ComputedCanUseFeature('team-actions-data-connector-code-blocks'),
    canUseConsolidatedActions: ComputedCanUseFeature('fin-processes-actions-consolidation'),
    canUseFinWorkflowsStepsInAllWorkflows: ComputedCanUseFeature(
      'fin-workflows-steps-in-all-workflows',
    ),
    canUseFinTaskSimpleMode: ComputedCanUseFeature('team-actions-fin-task-simple-mode'),
    canShowFinTaskSimpleModeInTemplatePreview: ComputedCanUseFeature(
      'team-actions-show-fin-task-simple-mode-in-template-preview',
    ),
    canUseWorkflowsWaitForCallback: ComputedCanUseFeature('team-actions-wait-for-webhook'),
    canUseAgenticWorkflows: ComputedCanUseFeature('team-actions-agentic-workflows'),
    canUseWorkflowsConversationTracingTool: ComputedCanUseFeature(
      'team-workflows-conversation-tracing',
    ),
    canUseWorkflowHeaderRedesign: ComputedCanUseFeature('workflow-header-redesign'),
    canUseNewDataExperience: ComputedCanUseFeature('fin-tasks-new-data-experience'),
    canUseDeterministicStepsInTasks: ComputedCanUseFeature(
      'team-actions-allow-deterministic-steps-in-tasks',
    ),
    canUseFinTasksAllChannels: ComputedCanUseFeature('team-actions-fin-tasks-all-channels'),
    canUseProceduresClosedBeta: ComputedCanUseFeature('procedures-closed-beta'),
    canUseProceduresAllowTaskCreation: ComputedCanUseFeature('procedures-allow-task-creation'),
    canUseProceduresReporting: ComputedCanUseFeature('procedures-reporting'),
    canUseFinTaskTemplate: ComputedCanUseFeature('answerbot-fin-task-v3'),
    canUseMcpActions: ComputedCanUseFeature('fin-mcp-actions'),
    canUseFinTaskAskAnExpert: ComputedCanUseFeature('team-actions-fin-tasks-ask-an-expert'),
    canUseFinTerminalStepV2: ComputedCanUseFeature('fin_terminal_step_v2'),
    canUseFinAssignmentFromWorkflows: ComputedCanUseFeature(
      'rd-services-fin-assignment-from-workflows',
    ),
    slimInsertableActions: ComputedCanUseFeature('team-actions-slim-insertable-actions'),
    canUseResolveConversation: ComputedCanUseFeature('team-actions-resolve-conversation'),

    //team-phone
    canUseChannelsVideoCall: ComputedCanUseFeature('channels-video-call'),
    canUseChannelsPhoneCall: ComputedCanUseFeature('channels-phone-call'),
    canUseInboundPhoneCall: ComputedCanUseFeature('inbound-phone-call'),
    canUsePhoneWorkflowTrigger: ComputedCanUseFeature('phone-workflow-trigger'),
    isCallingKillswitchEnabled: ComputedCanUseFeature('ae-calling-killswitch'),
    canFetchUserByPhoneNumber: ComputedCanUseFeature('ae-fetch-user-by-phone-number'),
    canUseDialpad: ComputedCanUseFeature('phone-dev-dialpad'),
    canUsePhoneCsat: ComputedCanUseFeature('phone-csat'),
    canUseAutomaticPhonePorting: ComputedCanUseFeature('automatic-phone-porting'),
    callingDropdownKillswitch: ComputedCanUseFeature('calling-dropdown-killswitch'),
    canManualAnswer: ComputedCanUseFeature('calling-manual-answer'),
    canUseFinVoiceWorkflowStep: ComputedCanUseFeature('fin-voice-workflow-step'),

    //team-data-foundations
    canUseHistoricalBulkSync: ComputedCanUseFeature('crm-salesforce-bulk-sync'),
    canSeeSyncErrorsNotificationIndicator: ComputedCanUseFeature('crm-new-sync-errors-indicator'),
    canOptInToSalesforceBeta: ComputedCanUseFeature('dev-platform-salesforce-opt-in-flow'),
    canUseCustomObjectsRequiredAttributes: ComputedCanUseFeature(
      'cdp-custom-objects-required-attributes',
    ),
    canMigrateFromZendesk: ComputedCanUseFeature('cdp-migrate-from-zendesk'),
    canImportFromZendeskNewUi: ComputedCanUseFeature('cdp-import-data-from-zendesk-new-ui'),
    canBypassIdVForFinPersistedDataDemo: ComputedCanUseFeature(
      'answerbot-bypass-idv-for-fin-persisted-data-demo',
    ),

    canListJiraSitesOnJiraIntegrationSettings: ComputedCanUseFeature(
      'team-actions-jira-integration-list-sites',
    ),
    canUseFinTaskV3: ComputedCanUseFeature('answerbot-fin-task-v3'),
    canUseFinTaskV3InAllWorkflows: ComputedCanUseFeature('answerbot-fin-task-v3-in-all-workflows'),
    canUseInstructionModelRouting: ComputedCanUseFeature('team-actions-instruction-model-routing'),
    canUseFinTaskAITaskGeneration: ComputedCanUseFeature(
      'team-actions-fin-task-ai-task-generation',
    ),
    canUseShopifyMultiStore: ComputedCanUseFeature('shopify-multi-store'),

    // actions-1-team
    canUseAiAgentWorkflows: ComputedCanUseFeature('answerbot-fin-actions-workflow-write-actions'),

    // team-conversational-knowledge
    canUseAiInsightsSuggestionsUi: ComputedCanUseFeature('ai-insights-suggestions-ui'),
    canUseCopilotGuidance: ComputedCanUseFeature('answerbot-copilot-guidance'),
    canUseExtractionExternalSources: ComputedCanUseFeature(
      'conversation-extraction-external-sources',
    ),

    canUseScheduledPublishing: ComputedCanUseFeature('team-conv-knowledge-scheduled-publishing'),
    canUseSalesforceArticleSynchroniser: ComputedCanUseFeature(
      'team-conv-knowledge-salesforce-article-synchronizer',
    ),

    // knowledge and data group features
    canUseDedicatedIPs: ComputedCanUseFeature('engage-channels-dedicated-ips'),
    canBumpCSVImportFileSizeLimit: ComputedCanUseFeature(
      'engage-systems-fixed-list-messaging-bump-filesize-limit',
    ),
    canOverrideMobileSmartLinkCondition: ComputedCanUseFeature(
      'group-engage-systems-smart-links-opt-in',
    ),
    canDisableInboundConversations: ComputedCanUseFeature('disable_inbound_conversations'),
    hasSavedContentFeature: ComputedCanUseFeature('macros_with_actions_billing_feature'),
    hasVersioningBillingFeature: ComputedCanUseFeature('ruleset_versioning'),
    canUseSenderRoleFilter: ComputedCanUseFeature('orchestration-sender-role-filter'),
    useCustomerTwilioAccount: ComputedCanUseFeature('orchestration-sms-customer-twilio-account'),
    canUseCustomKeywordResponses: ComputedCanUseFeature(
      'orchestration-sms-custom-keyword-responses',
    ),
    canUseSmsBeta: ComputedCanUseFeature('messages-sms-beta'),
    canUseDelayedAssigneeDropdown: ComputedCanUseFeature(
      'engage-systems-delayed-assignee-dropdown',
    ),
    canUseAlphanumericSenderId: ComputedCanUseFeature('engage-systems-sms-alphanumeric-sender-id'),
    canUseSeriesEmailUnsubscribeLinks: ComputedCanUseFeature(
      'engage-systems-series-email-unsubscribe-links',
    ),
    canUseSeriesMetaData: ComputedCanUseFeature('engage-systems-series-metadata'),
    ccIntercomPages: ComputedCanUseFeature('team-cc-pages'),
    // Context: https://github.com/intercom/intercom/issues/134467
    canUseManualAccountCreation: ComputedCanUseFeature('team-cc-manual-account-creation'),
    canUseMessagePointers: ComputedCanUseFeature('team-oe-message-pointers'),
    checklistRemindersQA: ComputedCanUseFeature('proactive-support-checklists-reminders-qa'),
    canUseReducedMatchSpacingPeriod: ComputedCanUseFeature(
      'proactive-support-reduced-match-spacing-period',
    ),
    canUseApifyAgressivePruning: ComputedCanUseFeature(
      'psg-external-content-apify-aggressive-pruning',
    ),
    canUseExternalContentReadibility: ComputedCanUseFeature(
      'can-use-readability-filter-for-extenal-content',
    ),
    canUseDeletedSurveyResponseStats: ComputedCanUseFeature('psg-deleted-survey-response-stats'),

    canUsePostsPreview: ComputedCanUseFeature('group-ps-posts-preview'),

    canUseSurveysResponseOrdering: ComputedCanUseFeature('psg-surveys-response-ordering'),
    shouldBypassTlsCutoffDate: ComputedCanUseFeature('tls-bypass-cutoff-date'),
    disableAutoSave: ComputedCanUseFeature('articles-disable-autosave'),
    canUseArticleReviews: ComputedCanUseFeature('article_reviews'),
    canUseChecklistsMultiHcInserters: ComputedCanUseFeature(
      'psg-multi-help-center-checklists-inserters',
    ),
    canUseLargerEmailPanelInSeries: ComputedCanUseFeature('psg-larger-email-panel-series'),
    canUseFinPlayground: ComputedCanUseFeature('answerbot-fin-playground'),
    canUseFinPlaygroundColdStart: ComputedCanUseFeature('fin-playground-cold-start'),
    canUseFinVoicePlaygroundDev: ComputedCanUseFeature('answerbot-fin-voice-playground-dev'),
    canUseFinVoiceRunbooks: ComputedCanUseFeature('answerbot-fin-voice-runbooks'),
    canUseFinVoiceToastRunbooks: ComputedCanUseFeature('answerbot-fin-voice-toast-runbooks'),
    canUseFinVoiceHeliosxOrderTracking: ComputedCanUseFeature(
      'answerbot-fin-voice-heliosx-order-tracking',
    ),
    canSetupFinVoicePhoneEasySetup: ComputedCanUseFeature('phone-fin-voice-easy-setup'),
    canUseMessengerNudges: ComputedCanUseFeature('team-standalone-messenger-nudges'),
    canUseFinVoiceTamilSupport: ComputedCanUseFeature('phone-fin-voice-tamil-support'),
    canUsePhoneFinVoiceFree: ComputedCanUseFeature('phone-fin-voice-free'),
    canUseFinVoiceUsageLimits: ComputedCanUseFeature('team-pnp-fin-voice-usage-limits'), // pnp-addproduct pnp-addmetric
    canUseFinPlaygroundTopics: ComputedCanUseFeature(
      'answerbot-fin-playground-question-generation-by-topic',
    ),
    canUseFinPlaygroundAudienceTargeting: ComputedCanUseFeature(
      'fin-playground-audience-targeting',
    ),
    canUseFinPlaygroundTestAsSelector: ComputedCanUseFeature('fin-playground-test-as-selector'),
    canUseFinPreviewImpersonationNewLeadOption: ComputedCanUseFeature(
      'fin-preview-impersonation-new-lead-option',
    ),
    canUseFinPlaygroundShowLastModified: ComputedCanUseFeature('fin-playground-show-last-modified'),
    canUseSophisticatedTestingCentralisedPage: ComputedCanUseFeature(
      'sophisticated-testing-centralised-page',
    ),
    canUseFileSourceInCopilot: ComputedCanUseFeature('group-ps-copilot-file-source-content'),
    canUseExternalContentInCopilot: ComputedCanUseFeature('group-ps-copilot-external-content'),
    canSelectConfluenceSubFolder: ComputedCanUseFeature('team-ki-select-confluence-sub-folder'),
    canUseConfluenceV2Client: ComputedCanUseFeature(
      'team-knowledge-foundations-confluence-use-v2-client',
    ),
    canUseIntegrationAppForSalesforce: ComputedCanUseFeature(
      'team-knowledge-interop-sfdc-integration',
    ),
    canUseFreshdeskIntegration: ComputedCanUseFeature(
      'team-knowledge-foundations-freshdesk-content-import',
    ),
    canUseDisableNoMarginClassTransformation: ComputedCanUseFeature(
      'team-kf-disable-no-margin-class-transformation',
    ),
    canUseFieldMapperForImportSource: ComputedCanUseFeature(
      'team-knowledge-foundations-import-source-field-mapping',
    ),
    canUseAudienceForCopilot: computed('features.[]', 'localStorageFeatures.[]', function () {
      return !this.canUseFeature('team-kds-copilot-audience-targeting-opt-out');
    }),

    canUseNewWebsiteSync: ComputedCanUseFeature('team-knowledge-foundations-new-website-sync'),
    canShowWebsiteSyncProgress: ComputedCanUseFeature(
      'team-knowledge-foundations-website-sync-progress',
    ),
    canUseRevampPreSync: ComputedCanUseFeature('team-knowledge-foundations-revamp-pre-sync'),
    canEnableFinForInternalArticles: ComputedCanUseFeature(
      'team-knowledge-foundations-enable-fin-internal-articles',
    ),
    canUseNewContentSearchV2: ComputedCanUseFeature(
      'team-knowledge-foundations-new-content-search-v2',
    ),

    showRegulatoryComplianceCountriesForSMS: ComputedCanUseFeature(
      'ps-regulatory-compliance-countries-for-sms',
    ),
    canUseHelpCenterFooterTextCustomization: ComputedCanUseFeature(
      'team-kds-customizable-help-center-footer-text',
    ),

    canUseEventMetadataGoals: ComputedCanUseFeature('psg-event-metadata-matching'),
    canUseArticleResultsShown: ComputedCanUseFeature('kds-can-use-article-results-shown'),

    canUseUnifiedContentUI: computed(
      'canUseStandalone',
      'features.[]',
      'localStorageFeatures.[]',
      function () {
        if (!this.canUseStandalone) {
          return this.canUseFeature('team-knowledge-foundations-content-setup-v2');
        }
        return this.canUseFeature('team-knowledge-foundations-standalone-content-setup-v2');
      },
    ),

    // team-proactive-support
    canUseTourFontProximaNova: ComputedCanUseFeature('outbound-tour-font-proxima-nova'),
    canUseMultipleDomainKeys: ComputedCanUseFeature('ps-multiple-domain-keys'),

    //team-psg-articles
    canUseArticleVersionSteps: ComputedCanUseFeature('articles-version-steps'),
    canUseArticleSuggestions: ComputedCanUseFeature('articles-content-suggestions'),

    //team-email
    canUseTeammateInviteCsvImport: ComputedCanUseFeature('team-email-teammate-invite-csv-import'),

    //team-pricing-and-packaging
    canUseBulkEditSeats: ComputedCanUseFeature('can-bulk-edit-seats'),
    hasMultipleSeatTypes: ComputedCanUseFeature('multiple_seat_types'),
    hasRoles: ComputedCanUseFeature('role_based_permissions'),
    hasMultipleSeatTypesPaywalled: ComputedCanUseFeature('multiple_seat_types_paywalled'),
    canSeeLastSeenDatesOnTeammateList: ComputedCanUseFeature(
      'can-see-last-seen-dates-on-teammate-list',
    ),
    canSeeBulkWhatsapp: ComputedCanUseFeature('team-pnp-can-see-bulk-whatsapp'),
    canFilterTeammateListDataByLastActive: ComputedCanUseFeature(
      'can-filter-teammate-list-data-by-last-active',
    ),
    canBulkDeleteTeammates: ComputedCanUseFeature('can-bulk-delete-teammates'),
    canUseSelectAllInTeammateList: ComputedCanUseFeature('can-use-select-all-in-teammate-list'),
    cannotSeePaymentFailureModal: ComputedCanUseFeature('team-pbe-hide-payment-failure-modal'),
    canSeePaymentFailureModal: not('cannotSeePaymentFailureModal'),

    cannotAssignWiderAccess: ComputedCanUseFeature('wm-permissions-cannot-assign-wider-access'),

    canUsePerProductPricingFlow: ComputedCanUseFeature('per-product-pricing-flow'),
    canUseArticles: ComputedCanUseFeature(ARTICLES_FEATURE),
    canUseInbox: ComputedCanUseFeature(INBOX_FEATURE),
    canUseMessages: ComputedCanUseFeature(MESSAGES_FEATURE),

    hasPricingMigrationUIFeature: ComputedCanUseFeature('show-stripe-migration-ui'),
    hasPricingMigrationImprovedFlowFeature: ComputedCanUseFeature('pnp-improved-ss-migration-flow'),
    canSeePricingMigrationUnderImpersonation: ComputedCanUseFeature(
      'pnp-qa-price-breakdowns-under-impersonation',
    ),
    canUseRealTimeSeatUpdates: ComputedCanUseFeature(
      'team-pricing-and-packaging-real-time-seat-usage',
    ),
    hasCopilotSeatType: ComputedCanUseFeature('copilot_seat_type_billing_feature'),
    hasUnlimitedCopilotAccessAddOn: ComputedCanUseFeature(
      'unlimited_fin_ai_copilot_access_billing_feature',
    ),
    canSkipActiveInvitesLimitCheck: ComputedCanUseFeature('pnp-skip-active-invites-limit-check'),
    isExpiredSubscriptionPageEnabledForDev: ComputedCanUseFeature(
      'team-purchase-experience-expired-subscription-page-enabled-for-dev',
    ),
    canUseSeatOverages: ComputedCanUseFeature('team-sales-led-growth-seat-overages'),
    hasSeatOveragesEnabled: or('canUseSeatOverages', 'isOptedOutOfSeatBlocking'),
    canUseNormalPaywallsOnStandalone: ComputedCanUseFeature('team-pnp-standalone-paywalls'),
    canUseOutcomesRenaming: ComputedCanUseFeature('fin-enable-outcomes'),

    //team-self-serve
    hasIntercomHomeDevelopmentMode: ComputedCanUseFeature('intercom-home-development-mode'),
    canSeeProfilingSurvey: ComputedCanUseFeature('team-activation-profiling-survey'),
    canUseGlobalSearch: ComputedCanUseFeature('team-product-guidance-global-search'),
    canSeeChurnBanner: ComputedCanUseFeature('team-self-serve-churn-banner'),
    canAccessSelfServeRestartSubscriptionWipModal: ComputedCanUseFeature(
      'team-self-serve-churn-save-restart-subscription-temporary-ff-wip',
    ),
    hideGlobalTrialBanner: ComputedCanUseFeature('team-expansion-hide-global-trial-banner'),
    teamPurchaseExperienceTrialExtensionsVariant: ComputedCanUseFeature(
      'team-purchase-experience-trial-extensions-variant',
    ),
    teamPurchaseExperienceTrialExtensionsControl: ComputedCanUseFeature(
      'team-purchase-experience-trial-extensions-control',
    ),
    disableFrontendAddressValidation: ComputedCanUseFeature(
      'team-purchase-experience-disable-address-validation',
    ),
    canSeeFinIncentiveOffer: ComputedCanUseFeature('team-self-serve-fin-incentives'),
    canUseFinEmailBranding: ComputedCanUseFeature('team-self-serve-fin-email-branding'),
    shouldHideCancelationSurvey: ComputedCanUseFeature(
      'team-self-serve-hide-cancelation-survey-for-select-customers',
    ),
    canSeeAiInsightsAddon: ComputedCanUseFeature('team-self-serve-ai-insights-addon'),

    //team-messenger
    canUseConditionalDisplayForVisitors: ComputedCanUseFeature(
      'visitor_messenger_conditional_display',
    ),
    canUseNewVamPredicates: ComputedCanUseFeature('messenger-new-vam-predicates'),
    hasTargetInboundConversationsFeature: ComputedCanUseFeature('target_inbound_conversations'),
    canUseUnbrandedMessenger: ComputedCanUseFeature('unbranded'),
    canUseNews: ComputedCanUseFeature('news'),
    canUseNewsPathPrefixForCustomDomain: ComputedCanUseFeature(
      'news_path_prefix_for_custom_domain',
    ),
    canUseSalesPreview: ComputedCanUseFeature('team-mobile-sales-preview'),
    canSearchBrowseWithoutHelpSpace: ComputedCanUseFeature('search-browse-without-help-space'),
    canUseIdvEnabledSignUp: ComputedCanUseFeature(
      'team-messenger-idv-enabled-on-signup-experiment-candidate',
    ),
    isNewInstallationPageCandidate: ComputedCanUseFeature(
      'team-messenger-messenger-install-page-experiment-candidate',
    ),
    hasNewMessengerInstallationPage: or('canUseIdvEnabledSignUp', 'isNewInstallationPageCandidate'),
    canUseAliasNames: ComputedCanUseFeature('team-messenger-admin-alias'),
    canUseMultipleIdvSecrets: ComputedCanUseFeature('workstream-idv-cycling'),
    canUseJwtSecuritySettings: ComputedCanUseFeature('messenger-jwt-security-settings'),
    canUseMobileJwtSecuritySettings: ComputedCanUseFeature(
      'team-messenger-mobile-jwt-security-settings',
    ),
    hideQuickReplies: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('answerbot-conversational-fin') &&
        (this.canUseFeature('answerbot-conversational-opt-in') ||
          !this.canUseFeature('answerbot-conversational-fin-opt-out'))
      );
    }),
    messengerCustomFonts: ComputedCanUseFeature('messenger-custom-fonts-pirateship'),

    //team-operator
    canUseOperatorQualifications: ComputedCanUseFeature('operator_qualification'),
    canUseVisitorAutoMessaging: ComputedCanUseFeature('visitor_auto_messaging'),
    canUseAppsInOperator: ComputedCanUseFeature('apps_in_operator'),
    hasHelpCenter: ComputedCanUseFeature('help_center'),
    hasEmbeddedArticles: ComputedCanUseFeature('embedded_articles'),
    canUseArticleAudienceTargeting: ComputedCanUseFeature('article_audience_targeting'),
    canUseWorkflowsNetNewExperience: ComputedCanUseFeature('workflows-net-new-experience'),
    hasVolumeControlPredictedAssignmentDeprecated: ComputedCanUseFeature(
      'predicted-assignment-volume-control-deprecated',
    ),
    hasFinIdentity: ComputedCanUseFeature('fin-identity'),
    canUseConversationAttributeChangedWorkflows: ComputedCanUseFeature(
      'conversation-attribute-changed-workflows',
    ),
    canUseAiSentimentAnalysis: ComputedCanUseFeature('ai-sentiment-analysis'),
    canUseCollectableDatetimeAttributes: ComputedCanUseFeature('collectable-datetime-attributes'),
    canUseFinAiCategories: ComputedCanUseFeature('team-workflows-fin-ai-routing'),
    canUseFinFirstAiCategories: ComputedCanUseFeature('fin-first-ai-categories'),
    canUseFinSdrTeammateUi: ComputedCanUseFeature('fin-sdr-teammate-ui'),
    canEnableComposerWhileWaitingForRating: ComputedCanUseFeature(
      'enable-composer-while-waiting-for-rating',
    ),
    canUseCSATRequestedForPredicate: ComputedCanUseFeature(
      'workflows-can-use-csat-requested-for-predicate',
    ),
    canUseGuidanceAppliedPredicate: ComputedCanUseFeature(
      'team-ai-agent-guidance-applied-predicate',
    ),
    canUseKnownComparisonForListPredicates: computed(
      'features.[]',
      'localStorageFeatures.[]',
      function () {
        return (
          this.canUseFeature('team-workflows-fin-ai-routing') ||
          this.canUseFeature('ai-conversation-classification')
        );
      },
    ),
    canUseInboundBotsSansReplyButtons: ComputedCanUseFeature('inbound-bots-sans-reply-buttons'),
    canUseMultilingualWorkflows: ComputedCanUseFeature('multilingual-workflows'),

    //team-ai-insights
    canSeeAiInsightsBeta: ComputedCanUseFeature('ai-insights-beta'),
    canSeeAiInsightsSummaries: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('ai-insights-beta') &&
        this.canUseFeature('ai-insights-summary-service') &&
        this.canUseFeature('ai-insights-summary-service-ui')
      );
    }),
    canSeeCxV2: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('ai-insights-cx-attributes-sda-reads') &&
        !this.canUseFeature('ai-insights-cx-v2-opt-out')
      );
    }),
    useNewCxSummary: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('ai-insights-beta') &&
        this.canUseFeature('ai-insights-cx-summary-sda-reads')
      );
    }),
    canSeeOptimizeWithReasons: ComputedCanUseFeature('ai-insights-optimize-with-reasons'),
    canUseTrendingTopics: ComputedCanUseFeature('ai-insights-trending-topics'),
    hasGettingStartedBackfill: ComputedCanUseFeature('ai-insights-getting-started'),
    canLinkToOptimizeReasons: ComputedCanUseFeature('ai-insights-link-to-optimize-reasons'),
    canSeeOptimizeCXScore: ComputedCanUseFeature('ai-insights-see-optimize-cx-score'),
    canSeeOptimizeSuggestions: ComputedCanUseFeature('ai-insights-optimize-with-suggestions'),
    canSeeOptimizeSuggestionsLink: ComputedCanUseFeature(
      'ai-insights-optimize-with-suggestions-link',
    ),

    //team-reporting
    canSeeReportsSharePermission: ComputedCanUseFeature('reporting--reports--share-permission'),
    isOnCsvBlockedList: ComputedCanUseFeature('csv-import-blockedlist'),
    canSeeCustomReportsAcademyLink: ComputedCanUseFeature(
      'custom-reports-enablement-banner-academy-link',
    ),
    canUseOperatorTeammateFilter: ComputedCanUseFeature('operator-teammate-filter'),
    canUseAttributesInFilters: ComputedCanUseFeature('reporting-attributes-in-filters'),

    isOptedOutOfSeatBlocking: ComputedCanUseFeature('team-people-seat-blocking-opt-out'),
    teammateTableDynamicQueries: ComputedCanUseFeature('teammate-table-dynamic-queries'),
    canSeeMetricsPlayground: ComputedCanUseFeature('reporting-metrics-playground'),
    canUseGoogleAnalytics4Integration: ComputedCanUseFeature('google-analytics-4-integration'),
    canUseTopicFilter: readOnly('hasConversationalInsightsBillingFeature'),

    hasConversationalInsightsBillingFeature: ComputedCanUseFeature('conversational_insights'),
    hasConverationalInsightsIntegrationExplicitlyDisabled: ComputedCanUseFeature(
      'insights-conversational-insights-disable-inbox-integration',
    ),
    canQueryPowerfulIndices: ComputedCanUseFeature('insights-powerful-indices'),
    hasCustomReportsBillingFeature: ComputedCanUseFeature('custom_reports'),
    canUseSyntheticReportingData: ComputedCanUseFeature('reporting-synthetic-data'),
    canSeeChatbotCsatReporting: ComputedCanUseFeature('chatbot-csat-reporting'),
    canUseCSATVOne: ComputedCanUseFeature('csat-version-one'),
    canSeeFullR2Experience: ComputedCanUseFeature('reporting-r2-full-experience'),
    cannotSeeDeprecatedReports: computed('features.[]', 'localStorageFeatures.[]', function () {
      return (
        this.canUseFeature('reporting-no-deprecated-reports') ||
        this.canUseFeature('reporting-r2-full-experience')
      );
    }),
    canSeeAiCsatMetrics: ComputedCanUseFeature('ai-insights-ai-csat-metrics'),
    canShareReportsInternally: ComputedCanUseFeature('reporting-internal-sharing'),
    // if we want to override the current date for a sales demo, we can opt the workspace
    // into a feature flag, e.g. reporting-override-today-as-2021-02-03
    reportingCurrentDateOverride: computed('features.[]', function () {
      let featureFlagMatch = this.features
        .map((f) => f.id.match(/^reporting-override-today-as-(?<date>.+)$/))
        .compact().firstObject;
      if (!featureFlagMatch) {
        return null;
      }
      return featureFlagMatch.groups['date'];
    }),
    canSeeNewChartLayout: ComputedCanUseFeature('reporting-new-chart-layout'),
    cannotSeeCSOverviewReport: ComputedCanUseFeature('reporting-no-cs-overview-report'),
    hasDeprecatedCSOverviewReport: ComputedCanUseFeature('reporting-deprecate-cs-overview-report'),
    canUseNewDataExport: ComputedCanUseFeature('reporting-new-data-export'),
    //team-inbox billing
    canUseConversationRatings: ComputedCanUseFeature('conversation_ratings'),
    canUseInboxSlas: ComputedCanUseFeature('inbox_conversation_sla_rules'),
    canUseTinyMinimumSlaDuration: ComputedCanUseFeature('tiny-minimum-sla-duration'),
    canUsePriorityRules: ComputedCanUseFeature('inbox_priority_rules'),
    canUseTagRules: ComputedCanUseFeature('inbox_conversation_tag_rules'),

    //team-inbox features
    canSeeSnowfall: ComputedCanUseFeature('respond-inbox-of-love-snowflakes'),
    canUseBackgroundInboxes: ComputedCanUseFeature('ember-inbox-background-inboxes'),
    canUseSavedRepliesFuzzySearch: ComputedCanUseFeature('team-inbox-saved-replies-fuzzy-search'),
    canUseInboxSearchInViews: ComputedCanUseFeature('inbox-search-in-views'),
    canSnoozeByHours: ComputedCanUseFeature('team-inbox-can-snooze-by-hours'),
    canUseEmailNotificationDestinationUrl: ComputedCanUseFeature(
      'email-notification-destination-url',
    ),
    canUseEmailAttachments: ComputedCanUseFeature('direct-mail-send-email-attachments'),
    canUseMacrosSettingsWithFiltersAndPagination: ComputedCanUseFeature(
      'inbox-macros-settings-with-filters-and-pagination',
    ),
    canRedactFromWebsockets: ComputedCanUseFeature('hsg-bpo-separation-websocket-redaction'),
    canAssignToTeamAndTeammate: ComputedCanUseFeature('maintain-conversation-context'),
    canUseCollapseConversationDetails: ComputedCanUseFeature('collapse-conversation-details'),
    canUseDisableNotificationForRepliesToUnassigned: ComputedCanUseFeature(
      'disable-notification-for-replies-to-unassigned',
    ),
    canUseElasticsearchInboxes: ComputedCanUseFeature('es-inboxes'),
    canUseCustomAddressPermission: ComputedCanUseFeature('custom-address-permission'),

    canOverrideSenderOnOsc: ComputedCanUseFeature('inbox_override_sender_on_osc'),
    canUseUserUpdaterListeners: ComputedCanUseFeature('inbox_allow_user_updater_listeners'),
    canSeeInboxConversationTranscriptsExport: ComputedCanUseFeature(
      'inbox__conversation_transcripts__export_permission',
    ),
    canUseSLAAdvanceWarningTrigger: ComputedCanUseFeature('sla-breach-advance-warning-trigger'),
    canUseSlackChannelInput: ComputedCanUseFeature('team-collaboration-slack-notifications-input'),
    canNotifyPrivateSlackChannel: ComputedCanUseFeature('notify-private-slack-channel'),
    canUseSlackLegacyApp: ComputedCanUseFeature('dev-platform-legacy-slack-integration'),
    excludeTicketsBalancedAssignment: ComputedCanUseFeature('filter-tickets-balanced-assignment'),
    canUseTicketsAssignmentSwitch: ComputedCanUseFeature(
      'team-tickets-2-tickets-assignment-switch',
    ),

    //team-inbox features
    canUseWorkloadManagement: readOnly('workloadManagementEnabled'),
    canUseAwaitingFirstReplyTrigger: ComputedCanUseFeature(
      'inbox_rules_awaiting_first_reply_event',
    ),
    hasMacros: ComputedCanUseFeature('macros_with_actions_billing_feature'),
    canUseMacros: reads('hasMacros'),
    canUseRoleCapacity: ComputedCanUseFeature('team-support-retain-role-level-capacity'),
    trackMacroSearches: ComputedCanUseFeature('team-sops-track-macro-searches'),
    canSetMacroVisibility: ComputedCanUseFeature('team_macros'),
    hasRealtimeMonitoring: ComputedCanUseFeature('realtime_monitoring'),
    canSeeConversationsPerHourMetric: ComputedCanUseFeature(
      'team-sops-realtime-conversations-per-hour',
    ),
    canSeeReassignAction: ComputedCanUseFeature('team-sops-reassign-action'),

    canUseLbaTagMatch: ComputedCanUseFeature('lba-tag-match'),
    canUseDisableEmailReassignment: ComputedCanUseFeature('team-sops-wlm-stop-email-reassignment'),
    canUseTeammateStatusPerWorkspace: ComputedCanUseFeature(
      'team-sops-use-per-workspace-away-status',
    ),
    canUseTeammateStatusAutoAwayMode: ComputedCanUseFeature(
      'team-sops-teammate-status-auto-away-mode',
    ),
    canEditTicketDesciptionDescriptions: ComputedCanUseFeature(
      'edit-ticket-description-descriptions',
    ),
    canUseWorkflowsTicketsV3: ComputedCanUseFeature('workflows-tickets-v3'),
    canSkipTicketsPortalIdvRequirement: ComputedCanUseFeature(
      'skip-tickets-portal-idv-requirement',
    ),
    // team-ai-agent
    canUseFinThumbsDown: ComputedCanUseFeature('fin-thumbs-down'),
    canUseFinGuidance: ComputedCanUseFeature('fin-guidance-closed-beta'),
    canUseThemeBasedRollout: ComputedCanUseFeature('ai-agent-theme-based-rollout'),
    canUseFinGuidanceReusablePreview: ComputedCanUseFeature('fin-guidance-use-reusable-preview'),
    canUseFinPreviewImpersonation: ComputedCanUseFeature('fin-preview-impersonation'),
    canUseFinPreviewAutoLanguageDetection: ComputedCanUseFeature(
      'fin-preview-auto-language-detection',
    ),
    canUseFinE2EPreview: ComputedCanUseFeature('ai-agent-fin-e2e-preview'),
    canUseAllAttributesInAIAudiences: ComputedCanUseFeature('all-attributes-in-ai-audiences'),
    canUseMBFAiAgentIdentities: ComputedCanUseFeature('mbf-ai-agent-identities'),
    canUseMultiBrandGA: ComputedCanUseFeature('multi-brand-for-fin-ga'),
    canUseCustomCsatMessageAfterFin: ComputedCanUseFeature(
      'rd-services-custom-csat-message-after-fin',
    ),
    canUseAccessFinAndAutomationSettingsPermission: ComputedCanUseFeature(
      'access-fin-and-automation-settings-permission',
    ),
    canOnlyShowOneFinDeploy: ComputedCanUseFeature('fin-first-only-show-one-fin-deploy-method'),
    canUseNewLabelForAbandoned: ComputedCanUseFeature('new-label-for-abandoned'),
    canUseNewLabelForRouted: ComputedCanUseFeature('new-label-for-routed'),
    canUseNewWorkflowChannelSetupBanner: ComputedCanUseFeature(
      'team-ai-agent-new-workflow-channel-setup-banner',
    ),

    //team-ai-agent-2
    canUseBatchTestEscalationMessage: ComputedCanUseFeature(
      'answerbot-playground-disable-human-available',
    ),
    canUseFinChangelog: ComputedCanUseFeature('fin-changelog'),
    canUseAudiencesInPreview: ComputedCanUseFeature('fin-preview-audience'),

    // team-inbox features
    canUsePerWorkspaceAdminAvatars: ComputedCanUseFeature('team-inbox-per-workspace-admin-avatars'),
    canUseConversationDetailsCompanySelect: ComputedCanUseFeature(
      'hsg-inbox-conversation-company-association',
    ),
    canUseAiAssistAutoFillTickets: ComputedCanUseFeature('ai_assist_auto_fill_tickets'),
    canUseAiConversationClassification: ComputedCanUseFeature('ai-conversation-classification'),
    canByPassMultibrandPaywall: ComputedCanUseFeature('multibrand-ignore-paywall'),
    canUseMultibrandBillingFeature: ComputedCanUseFeature('messenger_multibrand'),
    canUseMultibrandEmailBrandSda: ComputedCanUseFeature('multibrand-email-brand-sda'),
    hasBeenOnMultibrandBeta: ComputedCanUseFeature('has-been-on-multibrand-beta'),
    canViewMultilingualGlossaryPage: ComputedCanUseFeature('multilingual-glossary-page'),
    canViewAiTranslationPricing: ComputedCanUseFeature('multilingual-ai-translation-pricing'),
    canManageSharedCustomFolders: ComputedCanUseFeature('inbox-shared-custom-folders'),
    canManageInboxViewsPinnedColumns: ComputedCanUseFeature('inbox-views-pinned-columns'),
    canManageTeamAndTeammateLevelAccess: ComputedCanUseFeature('hsg-inbox-bpo-separation'),
    canUseDataConnectorsInInbox: ComputedCanUseFeature('inbox-use-data-connectors'),

    // team-ml features
    hasAnswerBot: ComputedCanUseFeature('answer_workflows'),
    hasDetailedActivityTracking: ComputedCanUseFeature('ember-ml-detailed-activity-tracking'),
    hasSampledActivityTracking: ComputedCanUseFeature('ember-ml-sampled-activity-tracking'),
    canUseFinCustomStep: ComputedCanUseFeature('fin-custom-step'),
    canUseFinCustomImageRecognition: ComputedCanUseFeature(
      'answerbot-fin-custom-image-recognition',
    ),

    //misc features
    shouldShowIntercomradeWarning: ComputedCanUseFeature('ember-enable-intercomrade-warning'),

    //BILLING:
    hasMultipleLanguages: ComputedCanUseFeature('multiple_language_support'),
    canUseRotatingAssignment: ComputedCanUseFeature('round_robin'),
    canUseFree: ComputedCanUseFeature('ember-purchase-free'),
    canUseRevenueReports: ComputedCanUseFeature('revenue_reports'),
    canUseCSVExport: ComputedCanUseFeature('inbox_csv_export'),
    workloadManagementEnabled: ComputedCanUseFeature('manage_capacity'),
    canUseBranchingQualification: ComputedCanUseFeature('branching_qualification'),
    canUseConversationRouting: ComputedCanUseFeature('conversation_routing'),
    hasAccountMarketingBillingFeature: ComputedCanUseFeature('account_marketing'),
    hasUpfrontEmailCollectionBillingFeature: ComputedCanUseFeature('upfront_email_collection'),
    hasDynamicAccountMessagesBillingFeature: ComputedCanUseFeature('dynamic_account_messages'),
    hasSalesforceSandboxFeatureInPlan: ComputedCanUseFeature('salesforce_sandbox'),
    canUseEmailForwarding: computed(
      'features.[]',
      'localStorageFeatures.[]',
      'products.[]',
      function () {
        return this.canUseFeature('email_forwarding');
      },
    ),

    canUseInboxRules: ComputedCanUseFeature('inbox_rules'),
    hasDefaultSenderAddress: ComputedCanUseFeature('default_sender_address'),

    //design systems
    canUseHasFeatureTest: ComputedCanUseFeature('has-feature-test-feature'),

    //team-app-security
    canSeeReactPersonalPreferences: ComputedCanUseFeature(
      'team-app-security-react-personal-preferences',
    ),
    canSkipSsoCleanupOnEmailChange: ComputedCanUseFeature(
      'app-security-skip-email-change-sso-account-clean-up',
    ),
    canUseSecurityHealthCheck: ComputedCanUseFeature('team-app-security-health-check'),

    // team-conversations
    isForbiddenFromUsingUserPresenceService: ComputedCanUseFeature(
      'ember-conversations-is-forbidden-from-using-user-presence-service',
    ),

    // team-channels
    canUseSwitchStatusFilter: ComputedCanUseFeature('switch-status-filter'),
    useWhatsappCloudApi: ComputedCanUseFeature('whatsapp-cloud-api'),
    canUseWhatsappOutbound: computed(
      'features.[]',
      'localStorageFeatures.[]',
      'products.[]',
      function () {
        return (
          this.canUseFeature('whatsapp_integration') &&
          this.canUseFeature('whatsapp_outbound_billing_feature')
        );
      },
    ),
    canRemoveConversationHistory: ComputedCanUseFeature(
      'channels-conversation-history-removal-setting',
    ),
    enableTwitterIntegration: ComputedCanUseFeature('enable-twitter-integration'),
    enableTwitterIntegrationBots: ComputedCanUseFeature('enable-twitter-integration-bots'),
    canUseRoleSidebarSectionConfiguration: ComputedCanUseFeature(
      'team-email-sidebar-section-configuration',
    ),

    // team-standalone
    canUseStandalone: readOnly('isStandaloneApp'),
    canUseStandaloneSalesforceCopilot: ComputedCanUseFeature('team-standalone-copilot-salesforce'),
    canUseStandaloneZendeskCopilotEarlyAccess: ComputedCanUseFeature(
      'team-standalone-zendesk-copilot-early-access',
    ),
    canUseStandaloneSalesforceCopilotEarlyAccess: ComputedCanUseFeature(
      'team-standalone-salesforce-copilot-early-access',
    ),
    canUseStandaloneDeployPhone: ComputedCanUseFeature('team-standalone-deploy-phone'),
    canInstallSalesforceUnlockedPackage: ComputedCanUseFeature(
      'team-standalone-salesforce-unlocked-package',
    ),
    canUseFinStandaloneRedirectFromSuite: ComputedCanUseFeature(
      'enable-fin-standalone-redirect-from-suite',
    ),
    canOptOutOfFinStandaloneRedirectFromSuite: ComputedCanUseFeature(
      'enable-fin-standalone-redirect-from-suite-opt-out',
    ),
    canSeeNewConversationSync: ComputedCanUseFeature('team-standalone-new-ticket-cases-sync'),
    canUseReusableWorkflowsInStandalone: ComputedCanUseFeature(
      'team-standalone-reusable-workflows',
    ),
    canUseEnglishVariations: ComputedCanUseFeature('language-support-english-versions'),
    allowAccessOutsideStandaloneSection: computed(
      'features.[]',
      'localStorageFeatures.[]',
      'isMigratingFromStandaloneToSuite',
      function () {
        return (
          this.canUseFeature('team-standalone-allow-access-outside-standalone-section') ||
          this.isMigratingFromStandaloneToSuite
        );
      },
    ),
    // we currently leave this feature flag enabled during and after the migration to suite
    hasStandaloneToSuiteMigrationFeature: ComputedCanUseFeature(
      'team-standalone-migrating-from-standalone-to-suite',
    ),
    canUseExternalArticlesAsFinContent: ComputedCanUseFeature(
      'ai-allow-external-articles-as-fin-content',
    ),
    canUseFinInOutboundDropdown: ComputedCanUseFeature('customer-agent-fin-outbound'),
    canUseHandoffToSalesforceChat: ComputedCanUseFeature(
      'team-standalone-handoff-to-salesforce-chat',
    ),
    canChangeContentImportState: ComputedCanUseFeature(
      'team-standalone-change-content-import-state',
    ),
    canUseMultipleWorkflows: ComputedCanUseFeature('team-standalone-multiple-workflows'),
    canUseSunshineQueueInformationMessage: ComputedCanUseFeature(
      'team-standalone-sunshine-queue-information-message',
    ),
    canUseUpdatedLauncherPredicates: ComputedCanUseFeature(
      'team-standalone-updated-launcher-predicates',
    ),
    canUseMoreAttachmentTypesInStandalone: ComputedCanUseFeature(
      'team-standalone-more-attachment-types',
    ),
    canSeeFinReportsWithoutConversationSyncing: ComputedCanUseFeature(
      'team-standalone-fin-reports-without-conversation-syncing',
    ),
    canSeeDataSecurityInStandalone: ComputedCanUseFeature('team-standalone-data-security-settings'),
    canUseZendeskOAuth: ComputedCanUseFeature('team-standalone-zendesk-oauth'),
    canUseSunshineOAuth: ComputedCanUseFeature('team-standalone-sunshine-oauth'),
    canUseConfirmResolution: ComputedCanUseFeature('team-standalone-confirm-resolution'),
    canUseStandaloneMultiEnv: ComputedCanUseFeature('team-standalone-multi-environment'),
    canUseSalesforceDigitalExperience: computed(
      'features.[]',
      'canUseStandalone',
      'hasStandalonePlatform',
      function () {
        return (
          this.canUseStandalone &&
          this.hasStandalonePlatform('salesforce') &&
          this.canUseFeature('team-standalone-salesforce-digital-experience-section')
        );
      },
    ),

    canUseStripeAppAuthFlow: ComputedCanUseFeature('cdp-stripe-auth-with-stripe-app-flow'),
    canUseStripeAppCreateUserWithMetadata: ComputedCanUseFeature(
      'df-stripe-integration-create-user-with-metadata',
    ),

    featureIdsSet: computed('features.[]', function () {
      let features = this.features || [];
      return new Set(features.map((feature) => feature.id));
    }),

    canUseFeatureWithoutLocalOverrides(featureIdentifier) {
      return this.canUseFeature(featureIdentifier, false);
    },
    canUseFeature(featureIdentifier, allowLocalOverrides = true) {
      let appId = this.id;
      if (this.isDestroyed || this.isDestroying) {
        return false;
      }

      if (IntercomradesProductsOverride.isEnabled(appId)) {
        return IntercomradesProductsOverride.features(this).includes(featureIdentifier);
      } else {
        return (
          (allowLocalOverrides && this.localStorageFeatures.includes(featureIdentifier)) ||
          (this.featureIdsSet && this.featureIdsSet.has(featureIdentifier))
        );
      }
    },
    // Alias for compatiability with the workspace model
    isFeatureEnabled(featureIdentifier) {
      return this.canUseFeature(featureIdentifier);
    },

    // team-frontend-tech
    canUseNexusEnhancedLogging: ComputedCanUseFeature('nexus-enhanced-logging'),

    // team-billing
    usagePageTweaksForFinBuckets: ComputedCanUseFeature(
      'billing-usage-page-tweaks-for-fin-buckets',
    ),

    // team-fin-nux
    canShowNewPersonalityComponent: ComputedCanUseFeature('team-fin-nux-new-personality-component'),
    customAnswersAreDeprecated: ComputedCanUseFeature('deprecated-custom-answers'),

    // team-omni
    canUseSlack: ComputedCanUseFeature('team-omni-slack'),
    canUseDiscordChannel: ComputedCanUseFeature('discord-channel'),

    canUseFinAgentApi: ComputedCanUseFeature('fin-agent-api'),

    // default-ff-tests do not change or activate in prod env
    testFeatureEnabledByGlobalFeatureFlagDefaults: ComputedCanUseFeature(
      nameForTestFeatureEnabledByGlobalFeatureFlagDefaults,
    ),
    testFeatureDisabledByGlobalFeatureFlagDefaults: ComputedCanUseFeature(
      nameForTestFeatureDisabledByGlobalFeatureFlagDefaults,
    ),

    init() {
      this._super(...arguments);
      this.refreshLocalStorageFeatures();
    },
    refreshLocalStorageFeatures() {
      this.set('localStorageFeatures', localFeatureFlags.list());
    },
    addLocalStorageFeature(featureKey) {
      localFeatureFlags.add(featureKey);
      this.refreshLocalStorageFeatures();
    },
    removeLocalStorageFeature(featureKey) {
      localFeatureFlags.remove(featureKey);
      this.refreshLocalStorageFeatures();
    },
  };
};

export default Mixin.create(generateFeatureFlagConfig());

// this list only includes features from the above config generation that have
// a direct call to ComputedCanUseFeature(). it DOES NOT include complex
// computed() fields, unless the feature names used inside the computed happen
// to also have sibling static flags using ComputedCanUseFeature()
export const ALL_STATIC_FEATURE_FLAG_NAMES = Object.values(
  generateFeatureFlagConfig({ flattenComputed: true }),
).filter((value) => typeof value === 'string');
